// extracted by mini-css-extract-plugin
export default {"container":"magnify_container__Ervej","hover_image":"magnify_hover_image__wwJ6S"};